import { createSlice } from "@reduxjs/toolkit";

const palette=createSlice({
  name:"palette",
  initialState:{c:0},
  reducers:{
		setPaletteS:(state,action)=>{state.c=action.payload}
  }
});

export const {setPaletteS}=palette.actions
export default palette.reducer